<template>
  <aside class="filters-drawer" :class="{ open: openProp }" :aria-hidden="!openProp">
    <div class="drawer-header"></div>

    <div class="drawer-body" v-if="openProp">
      <!-- Рендерим фильтры в указанном порядке -->
      <div v-for="(f, idx) in filtersOrder" :key="f.key" class="sidebar-item">
        <!-- compact button -->
        <template v-if="f.mode === 'button'">
          <button
            class="filter-toggle"
            :class="{ active: isActive(f.key) }"
            type="button"
            @click="openDetailFor(f, $event)"
          >
            <span class="label">{{ f.label }}</span>
            <span v-if="getActiveCount(f.key) > 0" class="badge">{{ getActiveCount(f.key) }}</span>
            <span class="arrow">▾</span>
          </button>
        </template>

        <!-- inline comps -->
        <template v-else>
          <div class="row-head">
            <div class="filter-inline">
              <span class="label">{{ f.label }}</span>
              <span v-if="getActiveCount(f.key) > 0" class="badge">{{ getActiveCount(f.key) }}</span>
            </div>
          </div>

          <!-- inline-wrapper выравнивает инлайн-компоненты по левому краю, как кнопки -->
          <div class="inline-wrapper" style="margin-top:8px;">
            <component
              :is="f.comp"
              @filter="onChildFilter"
              @openDetail="onChildOpenDetail"
              v-bind="f.props || {}"
              :initialRange="(draft && draft[f.key]) || (applied && applied[f.key]) || []"
              :initialSelected="(draft && draft[f.key]) || (applied && applied[f.key]) || []"
            />
          </div>
        </template>
      </div>
    </div>

    <div class="drawer-footer" v-if="openProp">
      <div class="sample-count">Образцов выбрано: <strong>{{ sampleCount }}</strong></div>
      <div class="footer-actions">
        <button type="button" class="btn-apply-all" @click="emitApplyAll">Показать на карте</button>
        <button type="button" class="btn-reset" @click="emitResetAll">Сбросить</button>
      </div>
    </div>
  </aside>
</template>

<script>
import { markRaw } from 'vue'

import ListFilter from '@/components/filters/ListFilter.vue'
import NumberRangeFilter from '@/components/filters/NumberRangeFilter.vue'
import GisCategoryFilter from '@/components/filters/GisCategoryFilter.vue'
import BasinFilter from '@/components/filters/BasinFilter.vue'
import StructureIFilter from '@/components/filters/StructureIFilter.vue'
import SystemFilter from '@/components/filters/SystemFilter.vue'
import DepartmentFilter from '@/components/filters/DepartmentFilter.vue'
import TierFilter from '@/components/filters/TierFilter.vue'
import SuiteHorizonFilter from '@/components/filters/SuiteHorizonFilter.vue'
import SampleOriginClassFilter from '@/components/filters/SampleOriginClassFilter.vue'
import ShortDescriptionFilter from '@/components/filters/ShortDescriptionFilter.vue'
import ResearchScaleFilter from '@/components/filters/ResearchScaleFilter.vue'
import ResolutionFilter from '@/components/filters/ResolutionFilter.vue'
import VoltageFilter from '@/components/filters/VoltageFilter.vue'
import CurrentMaFilter from '@/components/filters/CurrentMaFilter.vue'
import PorosityFilter from '@/components/filters/PorosityFilter.vue'
import PermeabilityFilter from '@/components/filters/PermeabilityFilter.vue'
import OtherLabDataFilter from '@/components/filters/OtherLabDataFilter.vue'
import TexturesCTFilter from '@/components/filters/TexturesCTFilter.vue'
import DepositionalEnvironmentFilter from '@/components/filters/DepositionalEnvironmentFilter.vue'

export default {
  name: 'FiltersDrawer',
  props: {
    open: { type: Boolean, default: false },
    draft: { type: Object, default: () => ({}) },
    applied: { type: Object, default: () => ({}) },
    sampleCount: { type: Number, default: 0 },

    // Новый: внешний (MapView) сообщает, какой фильтр открыт в FilterDetailPanel
    activeDetailKey: { type: String, default: null },
    detailOpen: { type: Boolean, default: false }
  },
  emits: ['update:open','draft-changed','open-detail','apply-all','reset-all'],
  components: {
    ListFilter,
    NumberRangeFilter,
    GisCategoryFilter,
    BasinFilter,
    StructureIFilter,
    SystemFilter,
    DepartmentFilter,
    TierFilter,
    SuiteHorizonFilter,
    SampleOriginClassFilter,
    ShortDescriptionFilter,
    ResearchScaleFilter,
    ResolutionFilter,
    VoltageFilter,
    CurrentMaFilter,
    PorosityFilter,
    PermeabilityFilter,
    OtherLabDataFilter,
    TexturesCTFilter,
    DepositionalEnvironmentFilter,
  },
  data() {
    return {
      _localRanges: {},
      // локальный активный ключ для мгновенной подсветки до апдейта родителя
      _localActiveKey: null,
      filtersOrder: [
        // { key: 'gis_category', label: 'Категория', comp: markRaw(GisCategoryFilter), mode: 'button', props: { options: ['Биология','Геммология','Геология','Осадки','Палеонтология'] } },
        { key: 'gis_category', label: 'Категория', comp: markRaw(GisCategoryFilter), mode: 'button', props: { options: ['Геология','Осадки','Палеонтология', 'Почва'] } },
        { key: 'basin', label: 'Бассейн', comp: markRaw(BasinFilter), mode: 'button', props: { options: ['Австралия','Байкал озеро','Баренцево море','Белое море','Волго-Уральский НГБ','Восточно-Сибирский НГБ','Восточно-Сибирское море','Западно-Сибирский НГБ','Индонезия','Карское море','Крымский п-о','Лено-Тунгусский НГБ','Норвегия','Огайо','Онежское озеро','Прикаспийский НГБ','Средиземное море','Тимано-Печорский НГБ','Черное море','шельф Вьетнама','Японское море'] } },
        { key: 'structure_i', label: 'Структура I порядка', comp: markRaw(StructureIFilter), mode: 'button', props: { options: ['Байкальская складчатая область','Балтийский щит','Башкирский свод','Бирская седловина','Борская депрессия','Бузулукская впадина','Вал Сорокина','Верхнекамская впадина','Демьянский мегавал','Жигулевско-Оренбургский свод','Жигулевско-Самаркинская система валов','Камовский свод','Колвависовская ступень','Мелекесская впадина','Непский свод','Непско-Ботуобинская антеклиза','Поднятие Де-Лонга','Покровско-Сорочинская зона поднятий','Предуральский краевой прогиб','Русско-Часельский мегавал','Северный свод','Северо-Татарский свод','Степновский вал','Турсунский мегавал','Уренгойский мегавал','Харьягинский вал','Хорейверская впадина','Южно-Татарский свод'] } },
        { key: 'department', label: 'Возраст', comp: markRaw(DepartmentFilter), mode: 'button', props: { options: ['C1','C2','D3','J2','K1','P','Q','Q holocene','верхний','голоцен','миоцен','нижний','олиоцен','плиоцен','средний'] } },
        { key: 'tier', label: 'Ярус', comp: markRaw(TierFilter), mode: 'button', props: { options: ['ааленский ярус','байосский ярус','батский ярус','артинский ярус','ассельский ярус','башкирский ярус','берриасский ярус','визейский ярус','волжский ярус','кунгурский ярус','лохковский ярус','московский ярус','сакмарский ярус','томмский ярус', 'атдабанский ярус', 'фаменский ярус', 'франский ярус'] } },
        { key: 'suite_horizon', label: 'Свита / горизонт', comp: markRaw(SuiteHorizonFilter), mode: 'button', props: { options: ['ачимовская свита','баженовская свита','берея','бобриковский горизонт','доманиковый горизонт','мячковский горизонт','овинпармский горизонт','осинский горизонт','преображенский горизонт','сотчемкыртинский, овинпармский горизонт','тюменская свита','усть-кутский горизонт','филипповский горизонт','юрубченская свита'] } },
        { key: 'sample_origin_class', label: 'Генезис', comp: markRaw(SampleOriginClassFilter), mode: 'button', props: { options: ['космогенный','метаморфический','осадочный обломочный','осадочный органогенно-обломочный','осадочный органогенный','осадочный хемогенно-обломочный','осадочный хемогенный','руда','рукотворный'] } },
        { key: 'short_description', label: 'Краткое описание', comp: markRaw(ShortDescriptionFilter), mode: 'button', props: { options: ['алевроглина','алевролит','алевролитово-песчаная порода','аргиллит','биокерамика','брекчия грязевулканическая','глина','глинисто-алевролитовая порода','глинисто-карбонатная порода','глинисто-кремнистая порода','глинисто-кремнисто-карбонатная порода','горная порода','гранат','граптолит','грунт','двустворка','доломит','жемчуг','зуб','известняк','искусственные материалы','искусственный образец','карбонатная порода','карбонатно-кремнистая порода','керогеново-кремнисто-карбонатная порода','корал','кость','кремнисто-карбонатная порода','лягушка','метеорит','окаменелое дерево','осадки','песок','песчаник','почва','ростр белемнита','руда','силицит','стекляные шарики','углеродисто-карбонатно-кремнистая порода','углеродное волокно','уголь','фораминифера','фундамент','часы','червь','чередование аргиллитов и доломитов','чередование аргиллитов и известняков'] } },
        { key: 'research_scale', label: 'Масштаб исследований', comp: markRaw(ResearchScaleFilter), mode: 'button', props: { options: ['Макро-КТ','Микро-КТ','Лаб. образец'] } },
        { key: 'resolution', label: 'Разрешение (мкм)', comp: markRaw(ResolutionFilter), mode: 'inline' },
        //{ key: 'voltage', label: 'Напряжение (kV)', comp: markRaw(VoltageFilter), mode: 'inline' },
        //{ key: 'current_ma', label: 'Ток (mA)', comp: markRaw(CurrentMaFilter), mode: 'inline' },
        { key: 'porosity', label: 'Пористость (%)', comp: markRaw(PorosityFilter), mode: 'inline' },
        { key: 'permeability', label: 'Проницаемость (мД)', comp: markRaw(PermeabilityFilter), mode: 'inline' },
        { key: 'other_lab_data', label: 'Другие лабораторные данные', comp: markRaw(OtherLabDataFilter), mode: 'button', props: { options: ['Капиллярометрия','Шлифы (фото и описание)','РЭМ (растровый электронный микроскоп)','ФЕС (фильтрационно-емкостные свойства)','Фото керна','Фото лаб. образцов','3Д-фото','КТ на второй энергии'] } },
        { key: 'textures_ct', label: 'Текстуры по КТ', comp: markRaw(TexturesCTFilter), mode: 'button', props: { options: ['волнисто-линзовидная','линзовидная','линзовидно-волнистая','линзовидно-волнистая биотурбированная','линзовидно-слоистая','массивная','массивная биотурбированная','неясно пятнисто-слоистая','неясно слоистая','неясно-пятнистая','параллельная с выклиниванием, линзовидная','параллельно слоистая','пятнистая','пятнисто-массивная','пятнисто-слоистая','рябь','слоистая','тонко слоистая','узловато-слоистая'] } },
        { key: 'depositional_environment', label: 'Обстановка осадконакопления', comp: markRaw(DepositionalEnvironmentFilter), mode: 'button', props: { options: ['морская','прибрежно-морская'] } },
      ]
    }
  },
  computed: {
    openProp: {
      get(){ return this.open },
      set(val){ this.$emit('update:open', val) }
    }
  },
  watch: {
    // когда внешняя detail-панель закрывается, очищаем локальный active
    detailOpen(newV) {
      if (!newV) this._localActiveKey = null
    }
  },
  methods: {
    onChildFilter(payload) {
      if (!payload || !payload.key) return
      this.$emit('draft-changed', payload)
    },

    onChildOpenDetail(payload) {
      if (!payload || !payload.key) return
      // синхронизируем локально
      this._localActiveKey = payload.key
      this.$emit('open-detail', payload)
    },

    openDetailFor(filter, evt) {
      if (evt && typeof evt.stopPropagation === 'function') evt.stopPropagation()
      const options = (filter.props && filter.props.options) || []
      // локально выставим активный ключ, чтобы UI моментально отреагировал
      this._localActiveKey = filter.key
      this.$emit('open-detail', { key: filter.key, options, label: filter.label })
    },

    localRange(key) {
      if (!this._localRanges) this._localRanges = {}
      if (!this._localRanges[key]) {
        const d = this.draft && this.draft[key]
        this._localRanges[key] = Array.isArray(d) && d.length === 2 ? { from: d[0], to: d[1] } : { from: 0, to: 0 }
      }
      return this._localRanges[key]
    },

    getActiveCount(key) {
      const pick = obj => obj && obj[key] !== undefined ? obj[key] : null
      const val = pick(this.draft) ?? pick(this.applied)
      if (!val) return 0
      if (Array.isArray(val)) return val.length || 0
      return 1
    },

    // определяем активность фильтра (учитываем внешнее состояние detail-панели и локальную подсказку)
    isActive(key) {
      if (this.detailOpen && this.activeDetailKey && this.activeDetailKey === key) return true
      if (this.detailOpen && this._localActiveKey && this._localActiveKey === key) return true
      return false
    },

    emitApplyAll() { this.$emit('apply-all') },
    emitResetAll() { this.$emit('reset-all') }
  }
}
</script>

<style scoped>
/* Панель фильтров: фиксирована в окне, верх и низ учитывают header/footer страницы */
.filters-drawer{
  position: fixed;
  top: var(--filters-top, calc(var(--header-height, 64px) + var(--top-controls-height, 72px)));
  left: 24px;
  min-width: 320px;
  width: auto;
  max-width: 520px;
  background: rgba(246,246,246,0.98);
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  padding: 8px;
  z-index: 1300;
  transform: translateX(-110%);
  opacity: 0;
  pointer-events: none;
  transition: transform .28s, opacity .18s;
  box-sizing: border-box;
  overflow: visible;

  /* общая максимальная высота панели (учитывает header + footer пространства) */
  display: block;
}

/* Когда открыта — используем flex колоночную модель:
   header (фикс.), body (растягивается и скроллится), footer (фикс. внизу). */
.filters-drawer.open{
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;

  display: block;
  max-height: calc(100vh - var(--filters-top, calc(var(--header-height, 64px) + var(--top-controls-height, 72px))) - (var(--map-footer-space, 120px) + 12px));
}

/* header панели (можете задать конкретную высоту, сейчас — минимальная) */
.drawer-header{
  height: 4px; /* если у вас есть содержимое — увеличьте */
  flex: 0 0 auto;
}

/* Тело панели: гибкая область, занимает всё доступное пространство и скроллится внутри.
   min-height:0 обязательно — чтобы flex-child корректно сжимался в некоторых браузерах. */
.drawer-body{
  flex: 1 1 auto;
  min-height: 0;
  /* Вычисляем максимальную высоту для тела: от общей max-height панели отнимаем фиксированные высоты header+footer/paddings
  Значение --filters-fixed-height можно подправить, чтобы учесть реальные header/footer высоты внутри панели. */
  max-height: calc(
  (100vh - var(--filters-top, calc(var(--header-height, 64px) + var(--top-controls-height, 72px))) - (var(--map-footer-space, 120px) + 12px))
  - var(--filters-fixed-height, 96px)
  );
  overflow-y: auto;
  margin-top: 8px;
  padding-right: 8px;
  padding-bottom: 8px; /* достаточно места у низу, чтобы кнопки не прилипали */
}

/* мелкие элементы списка фильтров */
.sidebar-item{
  padding: 6px 4px;
  border-bottom: 1px solid rgba(0,0,0,0.04);
  color: #222;
}

/* compact button */
.filter-toggle{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:10px 12px;
  border-radius:10px;
  background:transparent;
  border:none;
  cursor:pointer;
  font-weight:700;
  color:#222;
  border:1px solid rgba(0,0,0,0.04);
  transition: transform .14s ease, box-shadow .14s ease, background .14s ease;
}
.filter-toggle .label { font-weight:700; color:#222; }
.filter-toggle .arrow { margin-left:8px; color:#666; font-weight:700; transition: transform .18s ease; transform-origin:center; }

/* active state: подсветка и поворот стрелки */
.filter-toggle.active {
  background: linear-gradient(180deg, rgba(218, 219, 219, 0.521), rgba(117,228,245,0.06));
}
.filter-toggle.active .arrow { transform: rotate(-90deg); }

/* inline label styling (делает заголовок жирным и черным) */
.row-head .label { font-weight:700; padding-left:10px; color:#222; }

/* inline-wrapper сдвигает инлайн-компоненты немного правее */
.inline-wrapper { padding-left:6px; }

.badge{
  background:#222;
  color:#fff;
  font-weight:700;
  padding:2px 8px;
  border-radius:12px;
  margin:0 8px;
  font-size:12px;
}

.range-inline{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
  padding:8px 4px 10px 4px;
  flex-wrap:wrap;
}

.range-controls{
  display:flex;
  align-items:center;
  gap:8px;
  flex:1 1 auto;
  min-width:0;
}

.range-input{
  padding:8px;
  border-radius:8px;
  border:1px solid rgba(0,0,0,0.08);
  width:90px;
  max-width:35%;
  box-sizing:border-box;
}

.dash{
  color:rgba(0,0,0,0.5);
  font-weight:700;
  padding:0 4px
}

.range-actions{
  display:flex;
  gap:8px;
  align-items:center;
  flex:0 0 auto
}

/* кнопки с hover-подъёмом и тенью */
.btn, .btn-apply-all, .btn-reset, .btn-clear, .btn-clear-local {
  transition: transform .12s ease, box-shadow .12s ease;
}
.btn:hover, .btn-apply-all:hover, .btn-reset:hover, .btn-clear:hover, .btn-clear-local:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  cursor: pointer;
}

/* footer панели: прижимаем внизу через flex (margin-top:auto можно убрать) */
.drawer-footer{
  /* margin-top:auto;  <-- НЕ НУЖНО при flex-layout */
  flex: 0 0 auto;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:8px 4px;
  border-top:1px solid rgba(0,0,0,0.04);
}

.sample-count{ color:#222; font-weight:600 }

.footer-actions{ display:flex; gap:8px; align-items:center }

.btn-apply-all{
  background:var(--hp-button-color,#F6F6F6);
  color:var(--button-text-color,#222);
  padding:8px 12px;
  border-radius:8px;
  font-weight:700;
}
.btn-reset{
  background:transparent;
  border:1px solid rgba(0, 0, 0, 0.3);
  padding:8px 12px;
  border-radius:8px;
  color:#222;
  font-weight:700;
}

/* адаптив */
@media (max-width: 900px) {
  .filters-drawer { left: 12px; right: 12px; min-width: 0; max-width: calc(100% - 24px); }


  .filters-drawer.open{
  max-height: calc(100vh - var(--filters-top, calc(var(--header-height, 64px) + var(--top-controls-height, 72px))) - (var(--map-footer-space, 120px) + 12px));
  }


  /* drawer-body остаётся с ограничением по высоте и скроллом */
  .drawer-body{ padding-bottom: 12px; }
}


@media (max-width: 520px) {
  .filters-drawer { left: 8px; right: 8px; border-radius: 10px; }
  .drawer-body { padding-bottom: 12px; }
}
</style>